import { COMBAT_PROFILES, DYING_DURATION } from "../constants.js";
import { HURTBOX_PROFILES } from "../data/tuning.js";

export class Entity {
  constructor(scene, x, y, w, h, maxHp) {
    this.scene = scene;
    this.x = x;
    this.y = y;
    this.w = w;
    this.h = h;
    this.vx = 0;
    this.vy = 0;
    this.facing = 1;
    this.maxHp = maxHp;
    this.hp = maxHp;
    this.hurting = false;
    this.hurtTime = 0;
    this.dying = false;
    this.dieTime = 0;
    this.dead = false;
    this.markedForRemoval = false;
    this.hitStopTimer = 0;
    this.knockbackVx = 0;
    this.knockbackVy = 0;
    this.hurtGraceTimer = 0;
    this.lastCombatMode = "pve";
    this.hurtboxHeight = null;
    this.hurtboxTop = 0;
    this.hurtboxBottom = 0;
    this.setHurtboxProfile("default");
  }

  setHurtboxProfile(profileKey) {
    const profile = HURTBOX_PROFILES[profileKey] || HURTBOX_PROFILES.default;
    this.hurtboxHeight = profile.height ?? null;
    this.hurtboxTop = profile.top ?? 0;
    this.hurtboxBottom = profile.bottom ?? 0;
  }

  takeDamage(amount, knockbackDir = 0, combatMode = "pve") {
    const mode = COMBAT_PROFILES[combatMode] ? combatMode : "pve";
    const profile = COMBAT_PROFILES[mode];
    if (this.hurting || this.dying || this.dead || this.hurtGraceTimer > 0) return false;
    this.lastCombatMode = mode;
    this.hp -= amount;
    this.hitStopTimer = profile.hitStop;
    if (knockbackDir) {
      this.knockbackVx = knockbackDir * profile.knockbackX;
      this.knockbackVy = 0;
    }
    if (this.hp <= 0) {
      this.hp = 0;
      this.dying = true;
      this.dieTime = 0;
      return true;
    }
    this.hurting = true;
    this.hurtTime = 0;
    return false;
  }

  updateTimers(dt) {
    if (this.hitStopTimer > 0) {
      this.hitStopTimer = Math.max(0, this.hitStopTimer - dt);
    }
    if (this.hurtGraceTimer > 0) {
      this.hurtGraceTimer = Math.max(0, this.hurtGraceTimer - dt);
    }
    if (this.hurting) {
      const profile = COMBAT_PROFILES[this.lastCombatMode] || COMBAT_PROFILES.pve;
      this.hurtTime += dt;
      if (this.hurtTime >= profile.hurtDuration) {
        this.hurting = false;
        this.hurtTime = 0;
        this.hurtGraceTimer = profile.hurtGrace;
      }
    }
    if (this.dying) {
      this.dieTime += dt;
      if (this.dieTime >= DYING_DURATION) {
        this.dead = true;
      }
    }
  }

  getBounds() {
    if (this.hurtboxHeight != null) {
      return {
        x: this.x,
        y: this.y + this.h - this.hurtboxHeight,
        w: this.w,
        h: this.hurtboxHeight,
      };
    }
    return {
      x: this.x,
      y: this.y - this.hurtboxTop,
      w: this.w,
      h: this.h + this.hurtboxTop + this.hurtboxBottom,
    };
  }

  update(dt) {
    this.updateTimers(dt);
  }
}
